import {
  PendingPaymentInfo,
  PaymentTypeACH,
  PaymentTypeCREDITORDEBITMEDICAREGOV
} from '@cms-max/medicare-api-sdk'
import { rest } from 'msw'
import { isTest } from 'test-utils/isTest'
import { coreApiBase } from '../coreApiBase'

export const defaultPendingPaymentResponse: PendingPaymentInfo[] = [
  {
    submittedDateTime: '2022-09-20T19:28:51.000Z',
    agencyTrackingId: 'ACHMM21085010001000005',
    paymentMethodType: PaymentTypeCREDITORDEBITMEDICAREGOV.CreditOrDebitMedicareGov,
    total: 372.30
  },
  {
    submittedDateTime: '2022-08-20T11:03:20.000Z',
    agencyTrackingId: 'ACHMM21085010001000005',
    paymentMethodType: PaymentTypeACH.Ach,
    total: 26.38
  }
]

export function fetchPendingPaymentsSuccess ({
  pendingPayments = defaultPendingPaymentResponse,
  delay = isTest ? 0 : undefined
} = {}) {
  return rest.get(`${coreApiBase}/premiums/payments/pending`, (req, res, ctx) => {
    return res(
      ctx.delay(delay),
      ctx.status(200),
      ctx.json(pendingPayments)
    )
  })
}

export function fetchPendingPaymentsLoading () {
  return rest.get(`${coreApiBase}/premiums/payments/pending`, (req, res, ctx) => {
    return res(
      ctx.delay('infinite'),
      ctx.status(200),
      ctx.json([])
    )
  })
}

export function fetchPendingPaymentsFailure () {
  return rest.get(`${coreApiBase}/premiums/payments/pending`, (req, res, ctx) => {
    return res(ctx.delay(isTest ? 0 : undefined), ctx.status(500), ctx.json({}))
  })
}
